module.exports = __webpack_public_path__ + "img/Timing Logo.277bd972.png";